import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FormContactoComponent } from '../../widgets/form-contacto/form-contacto.component';
import { FormHubspotComponent } from '../form-hubspot/form-hubspot.component';
declare var hbspt: any;

@Component({
  selector: 'app-portada-fichas',
  templateUrl: './portada-fichas.component.html',
  styleUrl: './portada-fichas.component.scss'
})
export class PortadaFichasComponent {
  @Input() datos;
  @Input() carrer;
  @Input() venue;
  @Input() region;
  @Input() svgContent;
  @Input() paddingRight = "10vw";
  @Input() paddingLeft = "10vw";
  @Input() viewVenue = false;
  @Input() viewArea = false;
  @Input() posgrado = false;
  @Input() continua = false;
  @Input() grado = false;

  @ViewChild('containerPortadaFicha') container!: ElementRef;

  searhSvg = true;
  showStickyHeader = false;
  shortTitle = '';

  private lastScrollTop = 0;

  @HostListener('window:scroll', [])
  onWindowScroll() {

    if (!this.container?.nativeElement) return;

    this.checkHeaderSticky();
  }

  checkHeaderSticky() {
    const rect = this.container.nativeElement.getBoundingClientRect();
    const elementHeight = rect.height;

    // Punto medio del elemento respecto al viewport
    const midpoint = rect.top + (elementHeight / 3);

    // Si el punto medio está por encima del borde superior → salió la mitad
    const halfOut = midpoint < 0;

    this.showStickyHeader = halfOut;
    // --- 2️⃣ Nueva lógica: ocultar/mostrar el header global al hacer scroll ---
    const header = document.getElementById('header-container');
    const stickyHeader = document.getElementById('sticky-header');

    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (stickyHeader) {

      // Tolerancia mínima para considerar scroll real
      const delta = currentScroll - this.lastScrollTop;

      // Detectar si estamos en el fondo o arriba de todo (scroll bugfix)
      const atBottom = (window.innerHeight + currentScroll) >= document.body.offsetHeight - 5;
      const atTop = currentScroll <= 0;

      if (delta > 2 && !atBottom) {
        // Scrolleando hacia abajo → ocultar
        stickyHeader.style.top = (header.offsetHeight - 5) + "px";
      } else if (delta < -2 || atBottom || atTop) {
        // Scrolleando hacia arriba o estamos en un extremo → mostrar
        stickyHeader.style.top = header.offsetHeight + "px";

      }
      //styles
      let desktopBig = window.innerWidth > 1441;
      let desktop = window.innerWidth > 768;
      let mobBig = window.innerWidth < 768;

      let titleFontSticky = document.getElementById("title-font-sticky");
      if (titleFontSticky) {
        const pSize2 = this.getPSize2(mobBig, desktop, desktopBig);
        let sizeTitle2 = parseInt(this.datos.size_title) * pSize2;
        titleFontSticky.style.fontSize = sizeTitle2 + "px";

      }
    }



  }
  constructor(private http: HttpClient, private sanitizer: DomSanitizer, public dialog: MatDialog) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkStyles();
    this.checkHeaderSticky();

  }
  ngOnInit(): void {
    this.checkStyles();
  }
  ngAfterContentInit() {
    this.checkStyles();
  }
  resizeObserver: any;
  ignoreNextResize = false;

  ngAfterViewInit(): void {
    if (this.container?.nativeElement) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.ignoreNextResize) {
          this.ignoreNextResize = false;
          return;
        }
        this.checkStyles();
      });
      this.resizeObserver.observe(this.container.nativeElement);
    }
  }

  checkStyles() {
    if (this.datos) {

      let titleFont = document.getElementById("title-font");
      let subtitleFont = document.getElementById("subtitle-font");
      let titlesSection = document.getElementById("titles-section");
      let desktopBig = window.innerWidth > 1441;
      let desktop = window.innerWidth > 768;
      let mobBig = window.innerWidth < 768;
      let mob = window.innerWidth < 481;


      if (titleFont != null) {
        if (!this.svgContent && this.searhSvg) this.loadSvg()

        const pSize = this.getPSize(mobBig, desktop, desktopBig);
        let sizeTitle = parseInt(this.datos.size_title) * pSize;

        if (sizeTitle) {
          titleFont.style.fontSize = sizeTitle + "px";
        }
      }

      if (subtitleFont != null) {

        const pSize2 = this.getSubtitleSize(mobBig, desktop, desktopBig);
        let sizeTitle2 = parseInt(this.datos.size_title) * pSize2;


        if (sizeTitle2) {
          subtitleFont.style.fontSize = sizeTitle2 + "px";
        }
      }

      if (titlesSection) {
        titlesSection.style.paddingLeft = this.paddingLeft;
        titlesSection.style.paddingRight = this.paddingRight;
      }
    }
  }
  getPSize(mobBig: boolean, desktop: boolean, desktopBig: boolean): number {
    if (mobBig) return 0.55;
    if (desktop && !desktopBig) return 0.75;
    return 1;
  }
  getSubtitleSize(mobBig: boolean, desktop: boolean, desktopBig: boolean): number {
    if (mobBig) return 0.35;
    if (desktop && !desktopBig) return 0.55;
    return 0.75;
  }
  getPSize2(mobBig: boolean, desktop: boolean, desktopBig: boolean): number {
    if (mobBig) return 0.40;
    if (desktop && !desktopBig) return 0.55;
    return 0.70;
  }
  loadSvg(): void {
    if (this.datos.venue?.icono?.includes(".svg")) {
      this.http.get(this.createLink(this.datos.venue?.icono), { responseType: 'text' }).subscribe(svg => {
        const modifiedSvg = this.changeSvgColor(svg, "#ffffff");
        this.svgContent = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/svg+xml,' + encodeURIComponent(modifiedSvg));
      });
    }
    this.searhSvg = false;
  }
  createLink(item) {
    let url = environment.apiUrl + item
    return url
  }


  changeSvgColor(svg: string, color: string): string {
    return svg.replace(/fill: #[0-9a-fA-F]{6};/g, `fill: ${color};`);
  }

  goToLink(item: any): void {
    let sede = this.formatterSede(item.title);
    let url = '';
    if (this.grado) {
      url = '/es/ingreso/' + sede;
    }
    if (this.posgrado) {
      url = '/es/posgrados/' + sede;
    }
    if (this.continua) {
      url = '/es/educacion-continua/' + sede;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  formatterSede(title) {
    return title
      .trim()                         // elimina espacios al inicio y al final
      .toLowerCase()
      .replace(/[^a-záéíóúüñ0-9\s-]/gi, '') // conserva letras con acento, ñ y números
      .replace(/\s+/g, '-')            // reemplaza espacios por guiones
      .replace(/-+$/g, '');            // elimina guiones al final
  }

 openModalConsulta(): void {
  // 1. carrera de grado: hubspot
  if (this.grado) {
    this.openHubspotDialog('b2e6899b-83b4-4a49-92ff-92360afdd10d');
    return;
  }

  // 2. posgrado - form_hubspot
  if (this.posgrado && this.datos.form_hubspot) {
    const data ={ title: true };
    this.dialog.open(FormHubspotComponent, { data });
    return;
  }
  // 3. continua - form_hubspot
  if (this.continua && this.datos.form_hubspot) {
    const data = { formId: '8d3b3305-d944-466c-95a8-df7e2235b758', portalId: '23647426' };
    this.dialog.open(FormHubspotComponent, { data });
    return;
  }
  // 3. Caso por defecto: FormContactoComponent
  if (this.continua) {
    localStorage.setItem('curso', this.carrer);
  }

  const dialogRef = this.dialog.open(FormContactoComponent, {
    panelClass: 'custom-dialog-container'
  });

  dialogRef.componentInstance.closeModal.subscribe(() => {
    this.dialog.closeAll();
  });
}

// Función auxiliar privada para evitar repetir el portalId de HubSpot
private openHubspotDialog(formId: string): void {
  this.dialog.open(FormHubspotComponent, {
    data: { formId, portalId: '23647426' }
  });
}


}
